import React from "react";
import { Card, CardContent, CardHeader, Grid } from "@mui/material";
import AddressLine from "./AddressLineComponent";
import AddressComplexName from "./AddressComplexName";
import AddressUnitNumber from "./AddressUnitNumber";
import PostalCode from "./PostalCodeComponent";
import SelectComponent from "../Helpers/UserComponents/SelectComponent";
import { useSelector } from "react-redux";
import { MenuItemsForDropDown } from "@soqs/common";
import { dropdownoptions, dropdownsloading } from "../../features/trnAppSlice";

const ResidentialAddressComponent = () => {
  const dropdownopts = useSelector(dropdownoptions);
  const dropdownoptsloading = useSelector(dropdownsloading);

  return (
    <>
      <Grid>
        <Card>
          <CardHeader title="Residential Address" />
          <CardContent>
            <Grid container columnSpacing={1.5} rowSpacing={0.5}>
              <Grid size={{ xs: 12, md:6}}>
                <AddressUnitNumber
                  name="pitRegPhysicalAddressUnitNumber"
                  label="Unit Number"
                  maxLengths="8"
                  required={false}
                />
                <AddressComplexName
                  name="pitRegPhysicalAddressComplexName"
                  label="Complex Name"
                  maxLengths="27"
                  required={false}
                />
              </Grid>

              <Grid size={{ xs: 12, md:6}}>
                <AddressLine
                  name="pitRegPhysicalAddressStreetNumber"
                  label="Street Number"
                  maxLengths="8"
                  required={true}
                />
                <AddressLine
                  name="pitRegPhysicalAddressStreetName"
                  label="Street Name"
                  maxLengths="27"
                  required={true}
                />
              </Grid>

              <Grid size={{ xs: 12, md:6}}>
                <AddressLine
                  name="pitRegPhysicalAddressSuburb"
                  label="Suburb"
                  maxLengths="27"
                  required={true}
                />
              </Grid>

              <Grid size={{ xs: 12, md:6}}>
                <AddressLine
                  name="pitRegPhysicalAddressCity"
                  label="City"
                  maxLengths="27"
                  required={true}
                />
              </Grid>
              <Grid size={{ xs: 6, md:6}}>
                <SelectComponent
                  name="pitRegPhysicalAddressCountry"
                  label="Country"
                  options={MenuItemsForDropDown("country", dropdownopts, false)}
                  optionsloading={dropdownoptsloading}
                  defaultValue={"ZA"}
                  required
                />
              </Grid>

              <Grid size={{ xs: 6, md:2}}>
                <PostalCode
                  name="pitRegPhysicalAddressCode"
                  label="Code"
                  maxLengths="4"
                  required={true}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </>
  );
};
export default ResidentialAddressComponent;
